import { useEffect, useState } from "react";
import { Modal } from "react-bootstrap";
import SrvButton from "../../../components/global/SrvButton";
import axios from "axios";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faXmark } from "@fortawesome/free-solid-svg-icons";
import Avatar from 'react-avatar-edit'
import ErrorAdd from "../../../util/ErrorAdd";

function BlockMainAvatar(props) {
    const { show, onHide, id_type } = props;
    /*
        https://www.npmjs.com/package/react-avatar-edit
    */
    const [log, setLog] = useState(null);
    const [loading, setLoading] = useState(false);
    const [avatar, setAvatar] = useState(null);
    const [avatarOriginal, setAvatarOriginal] = useState(null);

    //ОТКРЫТИЕ/ЗАКРЫТИЕ МОДАЛЬНОЕ ОКНО
    useEffect(() => {
        //открытие
        if (show === true) {
            setLog(null);
            setLoading(false)
        }
    }, [show]);

    function loadingAvatar() {
        fetch(avatar)
            .then(res => res.blob())
            .then(blob => {

                let formData = new FormData();
                formData.append('File', blob, avatarOriginal.name);

                axios.post('/api_main/user/avatarUpload', formData)
                    .then((res) => {
                        if (res.data.Status != 1) {
                            setLog(res.Error);
                            setLoading(false);
                        }
                        else {
                            onHide();
                        }
                    })
                    .catch((err) => {
                        setLog('Неизвестная ошибка!');
                        setLoading(false);
                        ErrorAdd(err, window.location.href);
                    });
            });
    }

    function onCrop(img) {
        setAvatar(img);
    }

    function onFileLoad(img) {
        setAvatarOriginal(img);
    }


    return (
        <>
            <Modal show={show} onHide={onHide} >
                <Modal.Body>
                    <div className="modal_close" onClick={onHide}><FontAwesomeIcon icon={faXmark} className="opacity-50" /></div>


                    {loading === true ? (
                        <div className="loader_01"></div>
                    ) : (
                        <div className="row mt-20">
                            <div className="col-md-12">
                                <Avatar
                                    width={'450'}
                                    imageWidth={'450'}
                                    onCrop={onCrop}
                                    //exportSize={400}
                                    label="Выберите изображение..."
                                    onFileLoad={onFileLoad}
                                    exportAsSquare={true}
                                />
                            </div>
                        </div>
                    )}
                    {log !== null && <div className="form_error text-center mt-15">{log}</div>}
                    <div className="row mt-15">
                        <div className="col-md-12 text-center">
                            <SrvButton typeBtn="save" loading={loading} size={'lg'} onClick={() => loadingAvatar()} />
                        </div>
                    </div>
                </Modal.Body>
            </Modal>
        </>
    );
}
export default BlockMainAvatar;
